import React, { useEffect, useState } from "react"

import { statisticApi } from "@shared/apis"
import { toYYYYMMDD } from "@shared/modules"

const REFRESH_TIME = 60 * 1000

const Today = () => {
  const [todayViewersCount, setTodayViewersCount] = useState<number>()

  useEffect(() => {
    const getTodayViewerCounts = async () => {
      const today = toYYYYMMDD(new Date())

      const { data: todayViewersCount } = await statisticApi.todayViewers(
        today,
        today,
        1,
        1,
      )

      const todayStatistic = todayViewersCount.content[0]

      todayStatistic && setTodayViewersCount(todayStatistic.userCount)
    }

    const timer = setInterval(getTodayViewerCounts, REFRESH_TIME)

    getTodayViewerCounts()

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <li className="current">
      <label>오늘의 시청수</label>
      <p className="viewerCount">
        <strong>{todayViewersCount?.toLocaleString() ?? "-"}</strong>
      </p>
    </li>
  )
}

export default Today
